module.exports = __webpack_public_path__ + "img/events-icon-active.95169007.svg";